export default __webpack_public_path__ + "static/auto-185950f6a7cfef11de400d5197d40505.png";